// extracted by mini-css-extract-plugin
export default {"root":"CDgWJz","description":"gXfM6P","bold":"N8cF7H","button":"YA_d5r"};